export enum EMAIL_IDENTIFIER {
    GENERAL_CALLME = 'GENERAL_CALLME',
    PERSONALINJURY_SALES_COMPLETE = 'PERSONALINJURY_SALES_COMPLETE',
    PERSONALINJURY_CALLME = 'INJURY_CALLME',
}

export enum EMAIL_EVENT {
    OCCUPATION_NOT_SUPPORTED = 'OCCUPATION_NOT_SUPPORTED',
    AGE_ABOVE_68 = 'AGE_ABOVE_68',
    SALES_COMPLETE = 'SALES_COMPLETE',
    GENERAL_ERROR = 'GENERAL_ERROR',
    CUSTOMER_TOO_YOUNG = 'CUSTOMER_TOO_YOUNG',
    OTHER_POLICYHOLDER = 'OTHER_POLICYHOLDER',
    EXISTING_INSURANCE_LATE = 'EXISTING_INSURANCE_LATE',
}
export interface IEmailPayload {
    identifier: string;
    event: EMAIL_EVENT;
    fullName: string;
    phoneNumber: string;
    cpr?: string;
    occupation?: string;
    productName?: string;
    insuredAddress?: string;
}
export enum CUSTOMER_STATUS {
    BORNHOLM = 'BORNHOLM',
    AGE_ABOVE_68 = 'AGE_ABOVE_68',
    AGE_BELOW_18 = 'AGE_BELOW_18',
    MARKED = 'MARKED',
    INSURANCE_EXIST = 'INSURANCE_EXIST',
    PASS = 'PASS',
    FAILURE = 'FAILURE',
    NOT_SET = '',
}
